export const getInternalURL = url => {
    if (!url) {
        return url;
    }

    const parser = document.createElement('a');
    parser.href = url;
    return `${parser.pathname}${parser.search}${parser.hash}`;
};

export const isExternalURL = param => {
    try {
        const url = new URL(param, window.location.origin);
        return location.host !== url.host;
    } catch (e) {
        return false;
    }
};

export const parameters = {
    AFTER_LOGIN_REDIRECT_URL: 'redirectURL',
    REDIRECT_TYPE: 'redirectType',
    REDIRECT_TO_TOKYWOKY: 'redirectToPage',
    PENDING_OOS_SUBSCRIPTION: 'OOSSubscribe',
};

export const normalizePath = s => {
    const pathWithTrimmedSlashes = s
        .split('/')
        .filter(s => s)
        .join('/');
    const pathWithLeadingSlash = `/${pathWithTrimmedSlashes}`;
    return pathWithLeadingSlash;
};

export const removeExtraLeadingSlashes = url => url.replace(/^\/+/, '/');

/**
 * Return the object with url parameters
 * @param {string} params - comma separated list of the url parameter names
 * @returns {object|null} - an object of the url parameters key/value pairs
 */
export const getUrlParams = params => {
    if (!params) {
        return null;
    }

    let entries = {};
    const searchParams = new URLSearchParams(window.location.search);
    const keys = params.split(',');
    for (const [key, value] of searchParams.entries()) {
        if (keys.includes(key)) {
            entries = {
                ...entries,
                [key]: value,
            };
        }
    }
    return Object.keys(entries).length ? entries : null;
};
